import storageService from "./storageService";

/**
 * Returns the correct routing prefix based on the given tenant name.
 * If no tenant name is provided, it retrieves it from storage.
 * 
 * @param {string} [tenantName] Optional tenant name to evaluate.
 * @returns {string} The base route prefix for the tenant (e.g. '/zentres/').
 */
export const getTenantPrefix = (tenantName = null) => {
    if (!tenantName) {
        tenantName = storageService.getItem("Tenant_Name");
    }

    let prefix = '/zentcomm/';
    if (tenantName) {
        const tenant = tenantName.toLowerCase();
        if (tenant === 'main') {
            prefix = '/zentech/';
        } else if (['cascade', 'zentres'].includes(tenant)) {
            prefix = '/zentres/';
        } else if (['centrumaccess', 'procom', 'zentcorp', 'zentcomm', 'localhost', '127'].includes(tenant)) {
            prefix = '/zentcomm/';
        } else {
            // Default fallback if unknown
            prefix = '/zentcomm/';
        }
    }
    
    return prefix;
};
